import {React} from '@api';
import * as css from './ErrorCard.css'
export const ErrorCard : React.FunctionComponent<{error: Error}> = ({error}) => {
  return error?.message ? <div className={css.root}>
    {error.message}
  </div> : null
}


// WEBPACK FOOTER //
// ./src/shared/components/ui/components/ErrorCard.tsx